/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Delete_Row_DescriptionInputs */



/**
* | output |
* | --- |
* | "This row will be permanently deleted from the table." |
*
* @param {Datasets_Delete_Row_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_delete_row_description = /** @type {((inputs?: Datasets_Delete_Row_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Delete_Row_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Zeile wird dauerhaft aus der Tabelle gelöscht.")
	return /** @type {LocalizedString} */ ("This row will be permanently deleted from the table.")
});